import StrainTypeFilter from './strain-type-filter';

export default StrainTypeFilter;
